<div class="modal-overlay">
  <div class="card mx-auto modal-lg border-0">
    <div class="card-header bergh-bg-primary text-white h5">
      Materiaal toevoegen
    </div>
    <div class="card-body">
      <form [formGroup]="materialForm">
        <div class="row">
          <div class="col-12 mb-3">
            <label for="materialType"
              >Materiaal <span class="text-danger">*</span></label
            >
            <select
              id="materialType"
              class="form-control"
              formControlName="materialTypeId"
              (change)="onChangeMaterialType($any($event.target).value)"
              [ngClass]="{
                'is-invalid':
                  materialForm.get('materialTypeId').hasError('required') &&
                  isSubmittedForm
              }"
            >
              <option value="">Selecteer een optie</option>
              @for (materialType of materialTypes; track materialType) {
              <option [value]="materialType._id">
                {{ materialType?.nameDutch }}
              </option>
              }
            </select>
            @if (materialForm.get('materialTypeId').hasError('required') &&
            isSubmittedForm) {
            <div class="invalid-feedback">Dit veld is verplicht</div>
            }
          </div>

          <!-- Status field for installation technical facilities -->
          @if (firePartitionType ===
          FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY) {
          <div class="col-12 mb-3">
            <label for="materialStatus">Status</label>
            <select
              id="materialStatus"
              class="form-control"
              formControlName="materialStatus"
            >
              @for (materialStatus of materialStatuses; track materialStatus) {
              <option [value]="materialStatus.name">
                {{ materialStatus.nameDutch }}
              </option>
              }
            </select>
          </div>
          }

          <!-- Specification for regular fire partitions -->
          @if (materialSpecificationType) {
          <div class="col-12 mb-3">
            @if (materialSpecificationType === 'LIST' && materialSpecifications)
            {
            <label for="materialSpecification">Afmeting</label>
            } @if (materialSpecificationType === 'LIST' &&
            materialSpecifications) {
            <select
              id="materialSpecification"
              class="form-control"
              formControlName="materialSpecificationId"
              [ngClass]="{
                'is-invalid':
                  materialForm
                    .get('materialSpecificationId')
                    .hasError('required') && isSubmittedForm
              }"
            >
              <option value="">Selecteer een optie</option>
              @for (materialSpecification of materialSpecifications; track
              materialSpecification) {
              <option [value]="materialSpecification?._id">
                {{ materialSpecification?.name }}
              </option>
              }
            </select>
            } @if (materialSpecificationType === 'NONE' ||
            materialSpecificationType === 'MAINTENANCE') {
            <label for="materialSpecificationBrand">Merk</label>
            } @if (materialSpecificationType === 'NONE' ||
            materialSpecificationType === 'MAINTENANCE') {
            <input
              id="materialSpecificationBrand"
              type="text"
              class="form-control"
              formControlName="materialSpecificationBrand"
            />
            } @if (materialSpecificationType === 'NONE' ||
            materialSpecificationType === 'MAINTENANCE') {
            <label for="materialSpecificationText">Type / artikelnummer</label>
            } @if (materialSpecificationType === 'NONE' ||
            materialSpecificationType === 'MAINTENANCE') {
            <input
              id="materialSpecificationText"
              type="text"
              class="form-control"
              formControlName="materialSpecificationText"
            />
            } @if
            (materialForm.get('materialSpecificationId').hasError('required') &&
            isSubmittedForm) {
            <div class="invalid-feedback">Dit veld is verplicht</div>
            }
          </div>
          }

          <!-- Maintenance fields for installation technical facilities -->
          @if (firePartitionType ===
          FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY &&
          materialSpecificationType === 'MAINTENANCE') {
          <div class="col-12 mb-3">
            <label for="materialPlacedDate">Geplaatst op</label>
            <input
              id="materialPlacedDate"
              type="text"
              bsDatepicker
              placeholder="Geplaatst op"
              class="form-control"
              formControlName="materialPlacedDate"
              [bsConfig]="{
                dateInputFormat: 'DD-MM-YYYY',
                showWeekNumbers: false,
                adaptivePosition: true
              }"
            />
          </div>
          } @if (firePartitionType ===
          FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY &&
          materialSpecificationType === 'MAINTENANCE') {
          <div class="col-12 mb-3">
            <label for="materialMaintenanceDate">Laatste onderhoud</label>
            <input
              id="materialMaintenanceDate"
              type="text"
              bsDatepicker
              placeholder="Laatste onderhoud"
              class="form-control"
              formControlName="materialMaintenanceDate"
              [bsConfig]="{
                dateInputFormat: 'DD-MM-YYYY',
                showWeekNumbers: false,
                adaptivePosition: true
              }"
            />
          </div>
          } @if (firePartitionType ===
          FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY &&
          materialSpecificationType === 'MAINTENANCE') {
          <div class="col-12 mb-3">
            <label for="materialMaintenanceIntervalMonths"
              >Onderhoud (maanden)</label
            >
            <input
              id="materialMaintenanceIntervalMonths"
              placeholder="Onderhoud (maanden)"
              type="number"
              (keydown)="restrictDecimals($event)"
              class="form-control"
              formControlName="materialMaintenanceIntervalMonths"
            />
          </div>
          }

          <div class="col-12 mb-3">
            <label for="noOfUnits"
              >Aantal <span class="text-danger">*</span></label
            >
            <input
              id="noOfUnits"
              type="number"
              (keydown)="restrictDecimals($event)"
              class="form-control"
              min="1"
              formControlName="noOfUnits"
              [ngClass]="{
                'is-invalid':
                  (materialForm.get('noOfUnits').hasError('required') ||
                    materialForm.get('noOfUnits').hasError('min')) &&
                  isSubmittedForm
              }"
            />
            @if (materialForm.get('noOfUnits').hasError('required') &&
            isSubmittedForm) {
            <div class="invalid-feedback">Dit veld is verplicht</div>
            } @if (materialForm.get('noOfUnits').hasError('min') &&
            isSubmittedForm) {
            <div class="invalid-feedback">Aantal moet minimaal 1 zijn</div>
            }
          </div>

          <div class="col-12 mb-3">
            <label for="materialRemarks">Opmerkingen</label>
            <textarea
              id="materialRemarks"
              class="form-control"
              rows="3"
              formControlName="materialRemarks"
            ></textarea>
          </div>
        </div>
      </form>
    </div>
    <div class="card-footer bg-white d-flex justify-content-end">
      <button class="btn btn-secondary mr-2" type="button" (click)="onCancel()">
        Annuleren
      </button>
      <button
        class="btn bergh-btn-secondary text-white"
        type="submit"
        (click)="onSubmit()"
      >
        Opslaan
      </button>
    </div>
  </div>
</div>
